import { render } from "./StreamRegion.vue?vue&type=template&id=1c156622"
import script from "./StreamRegion.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamRegion.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamRegion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c156622"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c156622', __exports__)) {
    api.reload('1c156622', __exports__)
  }
  
  module.hot.accept("./StreamRegion.vue?vue&type=template&id=1c156622", () => {
    api.rerender('1c156622', render)
  })

}


export default __exports__